/**
 * cart-count-fallback.js — standalone, hand-written asset.
 * NOT a webpack build output (no dev/src source; restore from git if
 * `npm run clean`/`rebuild` deletes it, like photoswipe.js/flickity.js).
 *
 * theme.js's <cart-count> element reads event.detail.cart.item_count from
 * cart:updated / cart:refresh and treats a missing value as an empty cart,
 * so dispatchers that forward raw /cart/add.js responses (line items only,
 * no item_count) freeze or clear the header badge. For exactly those
 * payloads this listener resolves the real count from /cart.js and repairs
 * every <cart-count> badge. Payloads that already carry a numeric
 * item_count are left to theme.js untouched.
 */
(function () {
  'use strict';

  var pending = null;

  function cartJsUrl() {
    var tv = window.themeVariables;
    if (tv && tv.routes && tv.routes.cartUrl) return tv.routes.cartUrl + '.js';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart.js';
    }
    return '/cart.js';
  }

  function updateBadges(count) {
    var badges = document.querySelectorAll('cart-count');
    for (var i = 0; i < badges.length; i++) {
      if (count > 0) {
        badges[i].innerText = count;
        badges[i].classList.remove('hidden');
      } else {
        badges[i].innerText = '';
        badges[i].classList.add('hidden');
      }
    }
  }

  function onCartEvent(event) {
    var detail = event && event.detail;
    var itemCount = detail && detail.cart ? detail.cart.item_count : undefined;
    if (typeof itemCount === 'number') return;

    if (!pending) {
      pending = fetch(cartJsUrl(), { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          return cart && typeof cart.item_count === 'number' ? cart.item_count : null;
        })
        .catch(function () { return null; });
      pending.then(function () { pending = null; });
    }
    pending.then(function (count) {
      if (count !== null) updateBadges(count);
    });
  }

  document.documentElement.addEventListener('cart:updated', onCartEvent);
  document.documentElement.addEventListener('cart:refresh', onCartEvent);
})();
